var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    fetch_data: {
        group: '',
        fetch_name: '',
    },
    loading: false,
    status: 0,
    data: null,
    error: null,
    isLoading: false,
};
export var constructorLoaderSlice = createSlice({
    name: 'constructorLoader',
    initialState: initialState,
    reducers: {
        startLoading: function (state) {
            state.isLoading = true;
        },
        stopLoading: function (state) {
            state.isLoading = false;
        },
    },
});
export var startLoading = (_a = constructorLoaderSlice.actions, _a.startLoading), stopLoading = _a.stopLoading;
export default constructorLoaderSlice.reducer;
